import axios from 'axios';
import { ScenarioCageData } from 'views/bluviu-nutrition/features/scenarios-v2/types/scenario-cage-data.type';
import { ScenarioGeneration } from 'views/bluviu-nutrition/features/scenarios-v2/types/scenario-generation.type';

export const getGenerations = async (): Promise<ScenarioGeneration[]> => {
  // return generationsMock;
  const res = await axios.get<ScenarioGeneration[]>(`/ewosapi/v1/scenarios/gt2-multi/generations`);
  return res.data;
};

export const postGenerationSync = async (scenarioId: string, globalSiteId: string): Promise<ScenarioCageData[]> => {
  const res = await axios.post(`/ewosapi/v1/scenarios/gt2-multi/${scenarioId}/cage-data/sync?globalSiteId=${globalSiteId}`);
  return res.data;
};
